import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "aa-not-found",
  templateUrl: "./not-found.component.html",
  host: { class: "anonymous-page" },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotFoundComponent {}
